import Vue from 'vue'
import axios from 'axios'
import VueScrollTo  from 'vue-scrollto'
import Vuelidate from "vuelidate";
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

axios.defaults.baseURL = 'https://play.qubit.ng/'

Vue.use(VueScrollTo)
Vue.use(Vuelidate)

export const bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
